import Vue from "vue/dist/vue.common";

export default {
    state: {
        paySystem: [],
        props: []
    },
    actions: {
    },
    mutations: {
        setPaySystem(state, paysystem) {
            state.paySystem = paysystem;
        },
        setProps(state, props) {
            state.props = props;
        },
        setActivePaySystem(state, id) {
            state.paySystem = state.paySystem.map(paySystem => {
                Vue.set(paySystem, "CHECKED", (paySystem.ID === id) ? "Y" : "N");
                return paySystem;
            });
        }
    },
    getters: {
        paySystems(state, getters) {
            return state.paySystem;
        },
        activePaySystem(state, getters) {
            return getters.paySystems.find((paySystem) => paySystem.CHECKED === "Y");
        }
    },
    namespaced: true
}